import { Component, OnInit } from '@angular/core';
import { MonthDaysMockStore } from 'src/app/shared/store-mocks/month-days.store';
import { CreateFormFrequencyMonthDayStore } from './create-form-frequency-month-day.store';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-create-form-frequency-month-day',
  templateUrl: './create-form-frequency-month-day.component.html',
  styleUrls: ['./create-form-frequency-month-day.component.scss'],
  providers: [CreateFormFrequencyMonthDayStore, MonthDaysMockStore]
})
export class CreateFormFrequencyMonthDayComponent implements OnInit, ControlValueAccessor {

  constructor(
    public ngControl: NgControl,
    private store: CreateFormFrequencyMonthDayStore
  ) { 
    ngControl.valueAccessor = this;
  }

  vm$ = this.store.vm$
  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}



  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  frequencyMonthDayChange(value: any){
    this.modelChange(value)
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

}
